module.exports = __webpack_public_path__ + "static/t4-808a1c54cfadae72c232e34d49243c98.png";